/**
 * Imported first by `main.ts`: takes a remote support link out of the
 * address before any other module reads it. The hash router reads the
 * fragment when it is created and would take `#support=<id>.<secret>` for a
 * path — into its warnings and a `redirect` parameter. The link waits in
 * memory for the sign-in view (`supportLink.ts`).
 */
import { installSupportLinkIntercept, takeSupportLinkFromAddress } from './supportLink';

takeSupportLinkFromAddress();
// A link pasted into a tab that is already open changes only the fragment.
installSupportLinkIntercept();
